import {
  CLEAN_ADMIN_STAKEHOLDERS,
  SET_ADMIN_STAKEHOLDERS_FAILED,
  SET_ADMIN_STAKEHOLDERS_REQUEST,
  SET_ADMIN_STAKEHOLDERS_SCENARIO_SUCCESS,
  SET_ADMIN_STAKEHOLDERS_SUCCESS,
  SET_ADMIN_STAKEHOLDERS_LIST_SUCCESS
} from './types';

const initialState = {
  stakeholders: [],
  stakeholdersList: [],
  scenario: null,
  scenariosPath: null,
  totalCount: 0,
  loading: false,
  error: null,
};

export default function adminStakeholders(state = initialState, action) {
  switch (action.type) {
    case SET_ADMIN_STAKEHOLDERS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case SET_ADMIN_STAKEHOLDERS_SUCCESS:
      return {
        ...state,
        stakeholders: action.data,
        totalCount: action.total,
        loading: false,
        error: null,
      };
    case SET_ADMIN_STAKEHOLDERS_FAILED:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case SET_ADMIN_STAKEHOLDERS_SCENARIO_SUCCESS:
      return {
        ...state,
        scenario: action.data,
        loading: false,
        error: null,
      };
    case SET_ADMIN_STAKEHOLDERS_LIST_SUCCESS:
      return {
        ...state,
        stakeholdersList: action.data,
        loading: false,
        error: null,
      };
    case CLEAN_ADMIN_STAKEHOLDERS:
      return initialState;
    default:
      return state;
  }
}
